import React from "react";
import "./ruko.scss";
import Ruko1 from "./Ruko/ruko1";
import Ruko2 from "./Ruko1/ruko2";

const ruko = () => {
  return (
    <div id="ruko" className="ruko">
      <div className="container-header1"> Ruko Commercials</div>
      <div>
        <div className="Judul"></div>

        <Ruko1 />
        <Ruko2 />
      </div>
    </div>
  );
};

export default ruko;
